import React from 'react';
import {
  CCard,
  CCardHeader,
  CCardBody,
  CLabel,
  CFormGroup,
  CForm,
  CCardTitle,
  CInput, CImg, CTooltip,
} from '@coreui/react';
import { get } from 'lodash';
import classNames from 'classnames';
import { useFormikContext } from 'formik';
import Select from '../../shared/components/form/select/Select';
import { CustomizationFormProps } from '../types';
import tooltip from '../../assets/images/tool_tip.svg';

export const REVIEW_LINK_TYPES = [{
  label: 'Google',
  value: 'Please leave us a review on Google',
}, {
  label: 'Yelp',
  value: 'Please leave us a review on Yelp',
}, {
  label: 'Angie’s List',
  value: 'Please leave us a review on Angie’s List',
}];

const ReviewLink = () => {
  const formik = useFormikContext();
  const errors = formik.errors as CustomizationFormProps;

  const isInvalid = (fieldName: string) => get(formik.touched, fieldName) && get(formik.errors, fieldName);

  return (
    <CForm onSubmit={formik.handleSubmit}>
      <CCard className="glympser-container--roundedWithShadow">
        <CCardHeader className="glympser-roundedTop">
          <div className="d-flex align-items-center justify-content-between">
            <CCardTitle className="m-0">
              Feedback Review Link
              <CTooltip placement="top"
                        content="Allow users to leave Google, Yelp, or Angie’s list review when 4 or 5 stars feedback is given. See help for more information.">
                <CImg src={tooltip} className="ml-2 glympser-toolTip" />
              </CTooltip>
            </CCardTitle>

          </div>
        </CCardHeader>
        <CCardBody>
          <CFormGroup>
            <CLabel htmlFor="name">URL</CLabel>
            <CInput
              id="reviewLink"
              type="text"
              placeholder="Review Link URL"
              name="reviewLink"
              className={classNames({ 'is-invalid': isInvalid('reviewLink') })}
              {...formik.getFieldProps('reviewLink')}
            />
            {isInvalid('name') && <div className="invalid-feedback">{errors.reviewLink}</div>}
          </CFormGroup>
          <CFormGroup>
            <CLabel htmlFor="reviewLinkTitle">Type</CLabel>
            <Select
              isMulti={false}
              isClearable={false}
              name="reviewLinkTitle"
              id="reviewLinkTitle"
              options={REVIEW_LINK_TYPES}
              className={classNames({ 'is-invalid': isInvalid('reviewLinkTitle') })}
              classNamePrefix="select"
              {...formik.getFieldProps('reviewLinkTitle')}
              onBlur={() => formik.setFieldTouched('reviewLinkTitle', true, true)}
              onChange={(values) => formik.setFieldValue('reviewLinkTitle', values)}
            />
            {isInvalid('reviewLinkTitle') && <div className="invalid-feedback">{errors.reviewLinkTitle}</div>}
          </CFormGroup>
        </CCardBody>
      </CCard>
    </CForm>
  );
};

export default ReviewLink;
